import { action as apiAction } from 'api/Api'
import {
  remove as removeIncomingMail
} from 'store/redux/incomingMails'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  name: string
}

const requestRemoveIncomingMail = (payload: Payload) => async dispatch => {
  const { name } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeIncomingMail({
    name
  }))

  try {
    await apiAction('RemoveIncomingMail', {
      name
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestRemoveIncomingMail
